/**
 * Public build-time settings (Vite inlines VITE_* into the bundle). None of
 * these is a secret, and none may ever be: everything here ships to the browser.
 */
function required(name: string, value: string | undefined): string {
  if (!value) throw new Error(`${name} is not set. Copy apps/admin/.env.example to .env.local.`);
  return value.replace(/\/+$/, "");
}

export const config = {
  supabaseUrl: required("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required("VITE_SUPABASE_ANON_KEY", import.meta.env.VITE_SUPABASE_ANON_KEY),
  apiUrl: required("VITE_API_URL", import.meta.env.VITE_API_URL),
  siteUrl: (import.meta.env.VITE_SITE_URL ?? "https://fellowflats.com").replace(/\/+$/, ""),
};
